import { render } from "./LegacyAction.vue?vue&type=template&id=a97c4df8"
import script from "./LegacyAction.vue?vue&type=script&lang=js"
export * from "./LegacyAction.vue?vue&type=script&lang=js"
script.render = render

export default script